export const formatPaymentRangeToApi = (value?: any) => {
  if (value === "" || undefined || null) return "";
  if (!value?.startsWith("D")) return value;
  return parseInt(value?.replace(/\D/g, ""));
}

export const formatPaymentRangeFromApi = (value?: any) => {
  if (value === "" || undefined || null) return "";
  return `D + ${value}`;
}